/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function CDMHistoryGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();

  const history: any[] = [];
  const denominations: any[] = [];

  const denomsGrandTotals: any[] = [];

  let netNotes = 0;
  let netAmount = 0;

  requests.forEach((req) => {
    req.denominations.forEach((rep: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        denominations.push({ denomination: rep.denomination });
      }
    });

    const denoms: any = {};
    let notesTotal = 0;
    let amountTotal = 0;

    req.denominations.forEach((rep: any) => {
      denoms[rep.denomination] = rep.count;
      notesTotal += rep.count;
      amountTotal += rep.total;
    });

    netNotes += notesTotal;
    netAmount += amountTotal;

    const serviceInfo = {
      serialNo: req.serialNo,
      serviceDate: req.serviceDate,
      processingDate: req.processingDate,
      denoms,
      notesTotal,
      amountTotal,
      remarks: req.remarks,
    };

    history.push(serviceInfo);

    denomsGrandTotals.push(denoms);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Service Date
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Processing Date
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Denominations
            </th>

            <th
              rowSpan={2}
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Bank Notes
            </th>

            <th
              rowSpan={2}
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total Amount
            </th>

            <th
              rowSpan={2}
              style={{
                textAlign: "left",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {history.map((hry, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {hry.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {hry.serviceDate}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {hry.processingDate}
                </td>
                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {hry.denoms[denom] ? nf.format(hry.denoms[denom]) : 0}
                    </td>
                  );
                })}
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.notesTotal ? nf.format(hry.notesTotal) : 0}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.amountTotal ? nf.format(hry.amountTotal) : 0}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {hry.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={3}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              denomsGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {netNotes ? nf.format(netNotes) : 0}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {netAmount ? nf.format(netAmount) : 0}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(CDMHistoryGrid);
